import React, { useState, useEffect } from "react";
import '../../sass/components/flexibleModules/_components.lottieFileAnimationModule.scss';
import Slider from "react-slick";
import "../../sass/slick/slick.min.scss"
import "../../sass/slick/slick-theme.min.scss"
import VisibilitySensor from 'react-visibility-sensor';

const LottieFileAnimationModule = ({ data }) => {

    const [isRendered, setIsRendered] = useState(false);
    const [lottieMinHeight, setLottieMinHeight] = useState(0);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: false,
        // autoplaySpeed: 5500,
        cssEase: 'linear',
        arrows: true,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        centerMode: false,
        centerPadding: '250px',
        swipeToSlide: true,
        touchThreshold: 250,
        pauseOnHover: true,
        fade: true,
        beforeChange: function () {
            if (document.querySelector('.slick-current').offsetHeight) {
                setLottieMinHeight(document.querySelector('.slick-current').offsetHeight);
            }
        },
        afterChange: function (index) {
            changeLottie(index);
        }
    };
    useEffect(() => {
        setIsRendered(true);
    }, []);

    if (typeof document !== "undefined") {
        var scriptOne = document.createElement('script');
        scriptOne.src = '//unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
    }

    const changeLottie = (val) => {
        let prevLottie = -1;
        let nextLottie = -1;
        if(val === 0){
            prevLottie = data.lottieFileAnimationRepeater.length - 1;
            nextLottie = 1;
        }
        else if(val === data.lottieFileAnimationRepeater.length - 1){
            prevLottie = val - 1;
            nextLottie = 0;
        }
        else{
            prevLottie = val - 1;
            nextLottie = val + 1;
        }
        let animationNext = document.getElementById(`l-player${nextLottie}`);
        animationNext.seek(0);
        animationNext.pause();
        let animationPrev = document.getElementById(`l-player${prevLottie}`);
        animationPrev.seek(0);
        animationPrev.pause();

        let animation = document.getElementById(`l-player${val}`);
        animation.play();
        // animation.addEventListener("complete", () => {
        //     setTimeout(() => {

        //     }, 100);
        // });
    }

    function onChange(isVisible, index) {
        if (isVisible && index === 0) {
            let animation = document.getElementById(`l-player${index}`);
            animation.play();
        }
    }

    return (
        <div className="cp-lottieFileAnimationModule">
            <div className="cp-lottieFileAnimationModule__inner" style={{ minHeight: `${lottieMinHeight}px` }}>
                {data.lottieFileAnimationRepeater &&
                    <>
                        {isRendered && (
                            <Slider {...settings}>
                                {data.lottieFileAnimationRepeater.map((lottieItem, index) => (
                                    <div className={`cp-lottieFileAnimationModule__section`} key={index}>
                                        <div className="cp-lottieFileAnimationModule__section-top l--flex">
                                            {lottieItem.title &&
                                                <h2>{lottieItem.title}</h2>
                                            }
                                            {lottieItem.teaser &&
                                                <p dangerouslySetInnerHTML={{ __html: lottieItem.teaser }} />
                                            }
                                        </div>
                                        <div className="cp-lottieFileAnimationModule__section-bottom">
                                            <VisibilitySensor onChange={(e) => onChange(e, index)}>
                                                {lottieItem.link &&
                                                    <div className="cp-settingLottie">
                                                        <lottie-player key={index} id={`l-player${index}`} src={lottieItem.link} background="transparent" speed="1"></lottie-player>
                                                    </div>
                                                }
                                            </VisibilitySensor>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </>
                }
            </div>
        </div>
    );
}

export default LottieFileAnimationModule;